export default __webpack_public_path__ + "static/media/icon-coin-cwif.c6a085b9.svg";